const env = process.env.VUE_APP_ENV || 'test' // 本地开发调试默认使用test环境应用配置信息
export const ENV_MAP = {
  test: {
    1001: { // key为租户id
      corpId: 'ww8a53bac7a8929400', // 企微应用在此配置企业id
      appId: '1000061' // 企微应用在此配置应用id（提供企微后台中该应用的agentId和secret让运维生成）,活动签到
    }
  },
  uat: {
    1001: { // key为租户id
      corpId: 'ww8a53bac7a8929400', // 企微应用在此配置企业id
      appId: '1000061'// 企微应用在此配置应用id（提供企微后台中该应用的agentId和secret让运维生成）,活动签到
    }
  },
  prod: {
    1001: { // key为租户id
      corpId: 'ww8a53bac7a8929400', // 企微应用在此配置企业id
      appId: '1000061'// 企微应用在此配置应用id（提供企微后台中该应用的agentId和secret让运维生成）,活动签到
    }
  }
}

JSCONFIG['activity'] = JSCONFIG['activity'] || {}
global.APP_CONFIG = {
  auth_type: 'webAuthLogin', // webAuthLogin:网页授权登录接入企微， scanCodeAuthLogin:扫码授权登录接入企微， customAuthLogin:自定义登录
  ...global.APP_CONFIG,
  ...ENV_MAP[env][global.APP_CONFIG.tenantId],
  ...JSCONFIG['activity'][global.APP_CONFIG.tenantId] // ConfigMap中的配置key为”activity“，可以将相关配置放在ConfigMap
}
